import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbUserConstParam extends IAloDbBaseConstParam {
    USR_ID:number|null
    ENS_ID:number|null
    USR_CIVILITE:number|null    
    USR_NOM:string|null
    USR_PRENOM:string|null
    USR_LOGIN:string|null    
    USR_EMAIL:string|null
    USR_TEL:string|null
    USR_NOTE_INTERNE:string|null
    USR_PHOTO_URL:string|null
    ROLES:Array<string>|null
  }

export class AloDbUser extends AloDbBase {
        
    public USR_ID:number|null
    public ENS_ID:number|null
    public USR_CIVILITE:number|null  
    public USR_NOM:string|null
    public USR_PRENOM:string|null
    public USR_LOGIN:string|null    
    public USR_EMAIL:string|null
    public USR_TEL:string|null
    public USR_NOTE_INTERNE:string|null
    public USR_PHOTO_URL:string|null
    public ROLES:Array<string>|null
    
    constructor({USR_ID,ENS_ID,USR_CIVILITE,USR_NOM,USR_PRENOM,USR_LOGIN,USR_EMAIL,USR_TEL,USR_NOTE_INTERNE,USR_PHOTO_URL,ROLES,...args }:IAloDbUserConstParam = {} as IAloDbUserConstParam) {
        super(args)
        this.USR_ID = USR_ID
        this.ENS_ID = ENS_ID
        this.USR_CIVILITE = USR_CIVILITE        
        this.USR_NOM = USR_NOM   
        this.USR_PRENOM = USR_PRENOM   
        this.USR_LOGIN = USR_LOGIN                
        this.USR_EMAIL = USR_EMAIL   
        this.USR_TEL = USR_TEL   
        this.USR_NOTE_INTERNE = USR_NOTE_INTERNE   
        this.USR_PHOTO_URL = USR_PHOTO_URL   
        this.ROLES = ROLES
    }

    static createAloDbUserArray(datas:any) {
        return new AloBaseArray(AloDbUser,datas)
    }

    static createAloDbUserWithDetail(data:any) {
        return new AloDbUser({...data,detailLoaded:true})
    }
}
